import { FormattedMessage } from 'react-intl';

import { Typography } from '@/components/ui/typography';
import { useCurrencySymbol } from '@/hooks/use-currency-symbol';

import type { PostingResultData } from '../types';

interface ResultStatsProps {
  summary: PostingResultData['summary'];
  scenario: PostingResultData['scenario'];
}

export function ResultStats({ summary, scenario }: ResultStatsProps) {
  const { formatCurrency } = useCurrencySymbol();

  return (
    <div className="flex w-full items-start justify-between">
      <div className="flex flex-col gap-2">
        <Typography
          variant="caption"
          className="text-fx-neutral-400 tracking-wider uppercase"
        >
          <FormattedMessage
            defaultMessage="Openings submitted"
            description="Stats label for total openings submitted"
          />
        </Typography>
        <Typography variant="body2">{summary.openingsSubmitted}</Typography>
      </div>

      <div className="flex flex-col gap-2">
        <Typography
          variant="caption"
          className="text-fx-neutral-400 tracking-wider uppercase"
        >
          {scenario === 'all-success' ? (
            <FormattedMessage
              defaultMessage="Posted openings"
              description="Stats label for successfully posted openings count"
            />
          ) : (
            <FormattedMessage
              defaultMessage="Failed openings"
              description="Stats label for failed openings count"
            />
          )}
        </Typography>
        <Typography variant="body2">
          {scenario === 'all-success'
            ? summary.postedOpenings
            : summary.failedOpenings}
        </Typography>
      </div>

      <div className="flex flex-col gap-2">
        <Typography
          variant="caption"
          className="text-fx-neutral-400 tracking-wider uppercase"
        >
          <FormattedMessage
            defaultMessage="Channels"
            description="Stats label for the number of channels used"
          />
        </Typography>
        <Typography variant="body2">{summary.channels}</Typography>
      </div>

      <div className="flex flex-col gap-2">
        <Typography
          variant="caption"
          className="text-fx-neutral-400 tracking-wider uppercase"
        >
          <FormattedMessage
            defaultMessage="Total spend"
            description="Stats label for the total budget spent on successful postings"
          />
        </Typography>
        <Typography variant="body2">
          {formatCurrency(summary.totalSpend)}
        </Typography>
      </div>
    </div>
  );
}
